/**
 * Funkce pro přeformátování ceny z formátu xxxxx do xx xxx
 * @param  {Number} price Nenaformátovaná cena
 * @return {String}       Naformátovaná cena
 */
module.exports = function formatPrice (price) {
  price = price.toString();
  price = price.length > 3 ? price.slice(0, price.length - 3) + ' ' + price.slice(-3) : price;
  return price;
};